import config from '../config.json';
import axios from 'axios';

export class ViewService {
    constructor(name, params){
        this.name = name;
        this.params = params;
    }

    load = async () => {
        return (await axios.get(`${config.BASE_URL}views/${this.name}?${Object.keys(this.params || {}).map(key => `${key}=${this.params[key]}`).join("&")}`)).data;
    }

    save = async (payload) => {
        return (await axios.post(`${config.BASE_URL}views/${this.name}?${Object.keys(this.params || {}).map(key => `${key}=${this.params[key]}`).join("&")}`, payload)).data;
    }
}